import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@blueprintjs/core';

import cls from './ReportItem.module.css';

export default function (Component) {
  return class extends PureComponent {
    static propTypes = {
      data: PropTypes.object,
      isLast: PropTypes.bool,
      isSelectionMode: PropTypes.bool,
      isSelected: PropTypes.bool,
      isMovingMode: PropTypes.bool,
      isThisMoving: PropTypes.bool,
      movingOrdinal: PropTypes.number,
      onToggleSelected: PropTypes.func,
      onMovingModeSwitch: PropTypes.func,
      onMove: PropTypes.func,
      onMoveStep: PropTypes.func,
      onRemove: PropTypes.func,
    };

    render() {
      const { data, isMovingMode, isThisMoving, movingOrdinal } = this.props;

      if (!data) {
        return null;
      }

      const { ordinal } = data;

      if (isMovingMode) {
        return (
          <>
            {!isThisMoving && ordinal === 1 && <MovingSpace targetOrdinal={ordinal} onMove={this.props.onMove} />}
            <Component {...this.props} />
            {!isThisMoving && ordinal !== movingOrdinal - 1 && (
              <MovingSpace targetOrdinal={movingOrdinal < ordinal ? ordinal : ordinal + 1} onMove={this.props.onMove} />
            )}
          </>
        );
      }

      return <Component {...this.props} />;
    }
  };
}

class MovingSpace extends PureComponent {
  static propTypes = {
    targetOrdinal: PropTypes.number,
    onMove: PropTypes.func,
  };

  onMove = () => {
    const { targetOrdinal } = this.props;
    this.props.onMove(targetOrdinal);
  };

  render() {
    return (
      <div className={cls.movingSpace} onClick={this.onMove} data-cy="button-report-moving-space">
        <Icon className={cls.movingSpaceIcon} icon="selection" iconSize={Icon.SIZE_LARGE} />
        <span>Move selected element here</span>
      </div>
    );
  }
}
